module.exports = __webpack_public_path__ + "img/minamitsu murasa_lw.511c038e.png";